import { topologyConfig } from "components/Topology/configs/topologyConfig";
import { renderPrimitivesMethods } from "components/Topology/staticLayer/vectorElements/renderPrimitivesMethods";
import { topologyColors } from "components/Topology/configs/topologyColors";

const { nodeLinesGap } = topologyConfig;
const { blue500 } = topologyColors;
const { drawLine, drawIcon } = renderPrimitivesMethods;

export const renderConnectionsMethods = {
  drawTwoAngleLine(
    ref,
    {
      from,
      to,
      lineIdx = 0,
      linesCount = 1,
      gap = nodeLinesGap || 4,
      stroke,
      isWireless,
    },
  ) {
    const startX = from.x;
    const startY = from.y;
    const endX = to.x;
    const endY = to.y;

    const startYWithOffset =
      startY - ((linesCount - 1) * gap) / 2 + gap * lineIdx;
    const verticalLineX =
      startX +
      (endX - startX) / 2 -
      ((linesCount - 1) * gap) / 2 -
      gap * lineIdx;

    drawLine(ref, startX, startYWithOffset, verticalLineX, startYWithOffset, {
      stroke,
      isWireless,
    });
    drawLine(ref, verticalLineX, startYWithOffset, verticalLineX, endY, {
      stroke,
      isWireless,
    });
    drawLine(ref, verticalLineX, endY, endX, endY, { stroke, isWireless });
  },

  drawBottomLeftAngleLine(
    ref,
    {
      from,
      to,
      lineIdx = 0,
      linesCount = 1,
      gap = nodeLinesGap || 4,
      stroke,
      isWireless,
    },
  ) {
    const startX = from.x;
    const startY = from.y;
    const endX = to.x;
    const endY = to.y;

    const startXWithOffset =
      startX + ((linesCount - 1) * gap) / 2 - gap * lineIdx;

    drawLine(ref, startXWithOffset, startY, startXWithOffset, endY, { stroke });
    drawLine(ref, startXWithOffset, endY, endX, endY, { stroke, isWireless });
  },

  drawLeftBracketPolyLine(ref, from, to, leftGap, isWireless) {
    const startX = from.x;
    const startY = from.y;
    const endX = to.x;
    const endY = to.y;

    drawLine(ref, startX, startY, startX - leftGap, startY, { isWireless });
    drawLine(ref, startX - leftGap, startY, startX - leftGap, endY, {
      isWireless,
    });
    drawLine(ref, startX - leftGap, endY, endX, endY, { isWireless });
  },

  drawWirelessIcon(ref, startX, startY, r = 10) {
    const circle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "circle",
    );
    circle.setAttribute("cx", startX);
    circle.setAttribute("cy", startY);
    circle.setAttribute("r", r);
    circle.setAttribute("fill", blue500);
    ref.appendChild(circle);

    drawIcon(ref, startX - 8, startY - 8, {
      name: "wifi",
      size: 16,
      color: "#fff",
    });
  },
};
